import { ArrowClockwise, CheckCircle, Trash } from '@phosphor-icons/react';
import { Button } from '../Button';

interface ConnectionStatusViewProps {
  onReconnect: () => void;
  onDelete: () => void;
  loading: boolean;
  deleting: boolean;
}

export const ConnectionStatusView = ({
  onReconnect,
  onDelete,
  loading,
  deleting,
}: ConnectionStatusViewProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <CheckCircle className="h-16 w-16 text-success-500 mb-4" weight="fill" />
      <h3 className="text-lg font-semibold text-neutral-700 mb-2">
        Connection is established
      </h3>
      <span className="text-sm text-neutral-600 mb-6 block">
        You logged in and authorized access
      </span>
      <div className="flex gap-3">
        <Button onClick={onReconnect} disabled={loading || deleting}>
          <ArrowClockwise className="w-4 h-4 mr-2" />
          Reconnect
        </Button>
        <Button onClick={onDelete} disabled={loading || deleting} color="error">
          <Trash className="w-4 h-4 mr-2" />
          Delete
        </Button>
      </div>
    </div>
  );
};
